import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { AjaxRequest } from "@seriously-rad/seriouslyrad-framework-core/Server/AjaxRequest";
import { Application as ApplicationImport, ApplicationPropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Application";
import { ControlRef } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ControlRef";
import { Image } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Image";
import { Panel } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Panel";
import { WindowHeader } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/WindowHeader";

export class Application extends ApplicationImport
{
    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ApplicationPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                authenticationScheme: "Cookies",
                loginWithDialog: false,
            }
        };

    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected imageRef?: ControlRef<Image>;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ApplicationPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Protected Methods

    protected async _updateWindowHeaderImageAsync()
    {
        const
            name = "logo.svg",
            src = (await import(`./Ui/Styles/Images/${name}`)).default;

        this.imageRef?.current?.src.set(src);
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ApplicationPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.imageRef = new ControlRef();
    }

    protected override _createElementHtml()
    {
        return (
            <div>
                <WindowHeader>
                    <div class="spacer"></div>
                    <Image ref={this.imageRef} />
                </WindowHeader>
                <Panel ref={this._panelPageContainerControlRef} cssClass="rad-page-container pusher" elementTypeOverride="main" />
                <Panel ref={this._panelDialogContainerControlRef} cssClass="rad-dialog-container" />
            </div>
        );
    }
    protected override _createElementComplete()
    {
        super._createElementComplete();
        this._updateWindowHeaderImageAsync();
    }
    protected override _onUnauthenticatedAsync()
    {
        AjaxRequest.callQueue = [];
        AjaxRequest.unauthenticated = false;
        return super._onUnauthenticatedAsync();
    }

    // #endregion

    // #endregion
}